import { gql } from '@apollo/client';

export const TRACK_EVENT_MUTATION = gql`
    mutation trackEvent($name: String!, $uuid: String, $properties: JSON) {
        trackEvent(name: $name, uuid: $uuid, properties: $properties)
    }
`;
